/**
 * Vercel feature-branch detection (TASK-567 billing / TASK-565 subscriptions).
 *
 * True only for moving task branches like frontend-git-task-567-*.vercel.app
 * — NOT preprod (git-preprod), NOT stable test (git-test), NOT production.
 */
export function isVercelFeatureBranchDeploy() {
  const hostname = window.location.hostname;

  if (hostname.includes("localhost")) {
    return process.env.NODE_ENV === "development";
  }

  if (
    hostname === "autoshops.com" ||
    hostname === "www.autoshops.com" ||
    hostname.includes("git-main") ||
    hostname.includes("git-preprod") ||
    hostname.includes("preprod.autoshops.com") ||
    hostname.includes("staging") ||
    hostname.includes("git-test") ||
    hostname.includes("test.autoshops.com")
  ) {
    return false;
  }

  return hostname.includes("vercel.app") && hostname.includes("frontend-git-");
}
